import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Navigation from "./navigation";
import { Provider } from "react-redux";
import store from "./Redux/store";
function App() {
  return (
    <>
      <Provider store={store}>
        <div className="App">
          <BrowserRouter>
            <Navigation />
            <ToastContainer />
          </BrowserRouter>
        </div>
      </Provider>
    </>
  );
}

export default App;
